import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slider,
  Typography,
} from "@mui/material";
import { getDoc } from "firebase/firestore";
import { findIndex, forEach, some } from "lodash";
import UsuarioDb from "../../../../db/usuarioDb";
import moment, { Moment } from "moment-timezone";
import { LoadingButton } from "@mui/lab";
import Functions from "../../../../callable/functions";

type Props = {
  open: boolean;
  onClose: () => void;
  usuarioId: string;
};

export default function AlterarPontoDePartidaDialog({
  open,
  onClose,
  usuarioId,
}: Props) {
  const [mesesSlider, setMesesSlider] = useState<Moment[]>([moment()]);
  const [mesSelecionado, setMesSelecionado] = useState<Moment>();
  const [marks, setMarks] = useState<{ value: number; label: string }[]>([]);
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    if (!!usuarioId) {
      getDoc(new UsuarioDb().doc({ usuarioId })).then((doc) => {
        const usuario = doc.data();
        if (!!usuario) {
          const ontem = moment.tz("America/Sao_Paulo").subtract(1, "day");
          let dataIterada = moment.tz("2018-12-31", "America/Sao_Paulo");
          setMesSelecionado(usuario.dataInicio?.clone() ?? dataIterada.clone());
          let meses: Moment[] = [];
          while (dataIterada.isBefore(ontem)) {
            if (dataIterada.isSame(dataIterada.clone().endOf("month"), "day")) {
              meses.push(dataIterada.clone());
            }
            dataIterada.add(1, "day");
          }
          setMesesSlider(meses);
        }
      });
    }
  }, [usuarioId]);

  useEffect(() => {
    const finsDeAno: { value: number; label: string }[] = [];
    forEach(mesesSlider, (m, index) => {
      if (m.isSame(m.clone().endOf("year"), "month")) {
        finsDeAno.push({
          value: index,
          label: m.format("MMM/YY"),
        });
      }
    });
    setMarks(finsDeAno);
  }, [mesesSlider]);

  const salvarPontoDePartida = async () => {
    if (!!mesSelecionado) {
      setSalvando(true);
      await new Functions()
        .alterarPontoDePartida({ data: mesSelecionado?.format() })
        .catch(console.error)
        .finally(() => {
          setSalvando(false);
          onClose();
        });
    }
  };
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle color="text.primary" sx={{ typography: "h3" }}>
        Definir ponto de partida em{" "}
        <Typography variant="dataMono" fontSize="inherit" fontWeight={500}>
          {mesSelecionado?.format("MMM/YY")}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box p={4}>
          <Slider
            aria-label="Restricted values"
            track="inverted"
            valueLabelDisplay="on"
            sx={(theme) => ({
              // Marca e balão do slider em mono tabular.
              "& .MuiSlider-markLabel, & .MuiSlider-valueLabel": {
                ...theme.typography.dataMono,
                fontSize: 11,
              },
              "& .MuiSlider-valueLabel": {
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.text.primary,
                border: `1px solid ${theme.palette.divider}`,
              },
            })}
            value={findIndex(mesesSlider, (mes) =>
              mes.isSame(mesSelecionado, "month")
            )}
            onChange={(_e, value) =>
              setMesSelecionado(mesesSlider[value as number])
            }
            min={0}
            max={mesesSlider.length - 1}
            getAriaLabel={(m) => mesesSlider[m].format("MMM/YY")}
            getAriaValueText={(m) => mesesSlider[m].format("MMM/YY")}
            valueLabelFormat={(m) => mesesSlider[m].format("MMM/YY")}
            marks={some(marks) ? marks : []}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()} color="inherit">
          Cancelar
        </Button>
        <LoadingButton
          variant="contained"
          color="primary"
          loading={salvando}
          onClick={salvarPontoDePartida}
        >
          Salvar
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
